<template>
	<div v-loading="loading">
		<div class="app-container">
			<el-descriptions title="基本信息" :column="2" border>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-user"></i>
						字号名称
					</template>
					{{nbjbxx.traname}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-connection"></i>
						年报年度
					</template>
					{{nbjbxx.ancheyear}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-document-checked"></i>
						注册号
					</template>
					{{nbjbxx.regno}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-date"></i>
						年报时间
					</template>
					{{ parseTime(nbjbxx.anchedate, '{y}年{m}月{d}日') }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-phone"></i>
						联系电话
					</template>
					{{nbjbxx.tel}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-male"></i>
						年报状态
					</template>
					{{selectDictLabel(ifpubOptions,nbjbxx.ifpub)}}
				</el-descriptions-item>

				<el-descriptions-item span=2>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						从业人数(人)
					</template>
					{{nbjbxx.empnum}}
				</el-descriptions-item>

				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-school"></i>
						高校毕业生(经营人数)
					</template>
					{{nbjbxx.colgranum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-school"></i>
						高校毕业生（顾工人数）
					</template>
					{{nbjbxx.colemplnum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-user-solid"></i>
						退役士兵人数(经营人数)
					</template>
					{{nbjbxx.retsolnum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-user-solid"></i>
						退役士兵人数(顾工人数)
					</template>
					{{nbjbxx.retemplnum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-help"></i>
						残疾人(经营人数)
					</template>
					{{nbjbxx.dispernum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-help"></i>
						残疾人(顾工人数)
					</template>
					{{nbjbxx.disemplnum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-s-home"></i>
						失业再就业人员(经营人数)
					</template>
					{{nbjbxx.unenum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-s-home"></i>
						失业再就业人员(顾工人数)
					</template>
					{{nbjbxx.uneemplnum}}
				</el-descriptions-item>
			</el-descriptions>
			<div class="el-title">年报-网站网店信息</div>
			<el-table v-loading="loading" border :data="wzwdList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="网站类型" align="center" prop="webtype">
					<template slot-scope="scope">
						{{scope.row.webtype==='1'?'网站':'网店'}}
					</template>
				</el-table-column>
				<el-table-column label="网站（网店）名称" align="center" prop="websitname" />
				<el-table-column label="网站（网店）网址" align="center" prop="domain" />
			</el-table>
			<pagination v-show="totalWzwd>0" :total="totalWzwd" :page.sync="queryWzwdParams.pageNum"
				:limit.sync="queryWzwdParams.pageSize" @pagination="getNbGtWzWdxxList()" />
			<div class="el-title">年报-党建信息</div>
			<el-table v-loading="loading" border :data="djxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="党员（预备党员）人数" align="center" prop="numparm" />
				<el-table-column label="党组织建制" align="center" prop="parins">
					<template slot-scope="scope">
						{{selectDictLabel(parinsOptions,scope.row.parins)}}
					</template>
				</el-table-column>
				<el-table-column label="经营者是否党员" align="center" prop="resparmsign">
					<template slot-scope="scope">
						{{selectDictLabel(isornoOptions,scope.row.resparmsign)}}
					</template>
				</el-table-column>
				<el-table-column label="经营者是否党组织书记" align="center" prop="resparsecsign">
					<template slot-scope="scope">
						{{selectDictLabel(isornoOptions,scope.row.resparsecsign)}}
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="totalDjxx>0" :total="totalDjxx" :page.sync="queryDjxxParams.pageNum"
				:limit.sync="queryDjxxParams.pageSize" @pagination="getNbGtDjxxList()" />
			<div class="el-title">年报-新增许可信息</div>
			<el-table v-loading="loading" border :data="xkxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />	
				<el-table-column label="许可文件名称" align="center" prop="licname" />
				<el-table-column label="有效期至" align="center" prop="valto" />
			</el-table>
			<pagination v-show="totalXkxx>0" :total="totalXkxx" :page.sync="queryXkxxParams.pageNum"
				:limit.sync="queryXkxxParams.pageSize" @pagination="getNbXkList()" />
			<el-descriptions title="年报-资产状况信息" :column="2" border>

				<el-descriptions-item>
					<template slot="label">
						营业额或营业收入（万元）
					</template>
					{{zczkXx.vendinc}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						营业额或营业收入（是否公示）
					</template>
					{{selectDictLabel(isornoOptions,zczkXx.ifvendinc)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						纳税总额（万元）
					</template>
					{{zczkXx.ratgro}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						纳税总额（是否公示）
					</template>
					{{selectDictLabel(isornoOptions,zczkXx.ifratgro)}}
				</el-descriptions-item>

			</el-descriptions>
		</div>
	</div>
</template>

<script>
	import {
		listGtnbDjxx,
		listGtnbWdxx,
		listGtnbXkxx,
		listGtnbZczkxx,
	} from "@/api/qygzs/yqyd";

	export default {
		name: 'NbGtJbxxDetail',
		props: {
			//企业内部序号
			nbjbxx: {
				type: Object,
				require: true
			}
		},
		watch: {
			nbjbxx(newValue, oldValue) {
				this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {

				loading: false,
				// 选中数组
				ids: [],
				// 非单个禁用
				single: true,
				// 非多个禁用
				multiple: true,
				//【企业年报基本信息】总条数
				total: 0,
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},
				//网站网店
				queryWzwdParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},
				totalWzwd: 0,
				wzwdList: [],
				//党建信息
				queryDjxxParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},
				totalDjxx: 0,
				djxxList: [],
				//许可信息
				queryXkxxParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},
				totalXkxx: 0,
				xkxxList: [],

				//资产状况信息
				queryZczkParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},
				zczkXx: {},
				//年报状态字典
				ifpubOptions: [],
				//经营状态字典
				busstOptions: [],
				//公司类型字典
				anchetypeOptions: [],
				//是否字典
				isornoOptions: [],
				//出资方式字典
				conformOptions: [],
				//党组织建制字典
				parinsOptions: [],
			}
		},
		created() {
			this.init();
			this.getDicts("fdw_IFPUB").then(response => {
				this.ifpubOptions = response.data;
			});
			this.getDicts("fdw_BUSST").then(response => {
				this.busstOptions = response.data;
			});
			this.getDicts("fdw_ENTMIDCLASS").then(response => {
				this.anchetypeOptions = response.data;
			});
			this.getDicts("ISORNO").then(response => {
				this.isornoOptions = response.data;
			});
			this.getDicts("fdw_CONFORM").then(response => {
				this.conformOptions = response.data;
			});
			this.getDicts("fdw_PARINS").then(response => {
				this.parinsOptions = response.data;
			});


		},
		methods: {
			init() {
				this.loading = true;
				this.getNbGtDjxxList();
				this.getNbGtWzWdxxList();
				this.getNbXkList();
				this.getNbGtZczkxx();

			},
			//获取个体年报-党建信息
			getNbGtDjxxList() {
				this.loading = true;
				this.queryDjxxParams.ancheid = this.nbjbxx.ancheid;
				listGtnbDjxx(this.queryDjxxParams).then(response => {
					this.djxxList = response.rows;
					this.totalDjxx = response.total;
					this.loading = false;
				});
			},
			//获取个体年报-网站网店信息
			getNbGtWzWdxxList() {
				this.loading = true;
				this.queryWzwdParams.ancheid = this.nbjbxx.ancheid;
				listGtnbWdxx(this.queryWzwdParams).then(response => {
					this.wzwdList = response.rows;
					this.totalWzwd = response.total;
					this.loading = false;
				});
			},
			//获取个体年报-许可信息
			getNbXkList() {
				this.loading = true;
				this.queryXkxxParams.ancheid = this.nbjbxx.ancheid;
				listGtnbXkxx(this.queryXkxxParams).then(response => {
					this.xkxxList = response.rows;
					this.totalXkxx = response.total;
					this.loading = false;
				});
			},

			//获取年报-资产状况信息
			getNbGtZczkxx() {
				this.loading = true;
				this.queryZczkParams.ancheid = this.nbjbxx.ancheid;
				listGtnbZczkxx(this.queryZczkParams).then(response => {
					if (response.rows.length > 0) {
						this.zczkXx = response.rows[0];
					}
					this.loading = false;
				});
			},

		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
